
export class TipoComunicacao {

    public id: string;
    public nome: string;

    constructor(){
        
    }
}
